import React, { useState, useEffect } from "react";

// CSS
import "./../../../assets/css/purchase/datatable.css";

// Utils
import { formatCurrency, getData } from "../../../utils/SamuiUtils";
import { formatDate } from "../../../utils/DateUtils";
import FileModal from "../../components/Modal/FileModal";
import PoSelectionModal from "../../components/Modal/PoSelectionModal";

const DataTable = ({
  currentItems,
  onRowSelected,
  onRevise,
  currentPage,
  handlePageChange,
  dataMasterList,
  itemsPerPage,
  fieldMappings,
  getReport,
  updateStatus,
}) => {
  // State สำหรับเก็บ ID แถวที่เลือก
  const [selectedRow, setSelectedRow] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showConfirmModal2, setShowConfirmModal2] = useState(false);
  const [selectedDocNo, setSelectedDocNo] = useState(null);
  const [POList, setPOList] = useState([]);
  const [poStatusMap, setPoStatusMap] = useState({});

  const handleClose = () => {
    setShowModal(false);
  };

  const handleShowModal = (files) => {
    setSelectedFiles(files);
    setShowModal(true);
  };

  // เอามาใช้สำหรับหน้าใบจ่าย ให้ดักว่าเป็นผู้ขาย หรือ ลูกค้า
  const getApOrArCode = (data) => {
    return data[fieldMappings.apCode] || data[fieldMappings.apName]
      ? { code: data[fieldMappings.apCode], name: data[fieldMappings.apName] }
      : { code: data["AR_Code"], name: data["AR_Name"] };
  };

  const renderPageNumbers = () => {
    // Safety check: ถ้า dataMasterList เป็น undefined หรือไม่ใช่ array ให้ return empty array
    if (!dataMasterList || !Array.isArray(dataMasterList)) {
      return [];
    }

    const totalPages = Math.ceil(dataMasterList.length / itemsPerPage);
    const pages = [];
    const maxVisiblePages = 5;
    const range = 2;

    if (totalPages > maxVisiblePages) {
      pages.push(
        <li
          key={1}
          className={`paginate_button page-item ${currentPage === 1 ? "active" : ""
            }`}
        >
          <a href="#" className="page-link" onClick={() => handlePageChange(1)}>
            1
          </a>
        </li>
      );

      if (currentPage - range > 2) {
        pages.push(
          <li key="ellipsis-start" className="paginate_button page-item">
            <a href="#" className="page-link">
              ...
            </a>
          </li>
        );
      }

      for (
        let i = Math.max(currentPage - range, 2);
        i <= Math.min(currentPage + range, totalPages - 1);
        i++
      ) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""
              }`}
          >
            <a
              href="#"
              className="page-link"
              onClick={() => handlePageChange(i)}
            >
              {i}
            </a>
          </li>
        );
      }

      if (currentPage + range < totalPages - 1) {
        pages.push(
          <li key="ellipsis-end" className="paginate_button page-item">
            <a href="#" className="page-link">
              ...
            </a>
          </li>
        );
      }

      pages.push(
        <li
          key={totalPages}
          className={`paginate_button page-item ${currentPage === totalPages ? "active" : ""
            }`}
        >
          <a
            href="#"
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </a>
        </li>
      );
    } else {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""
              }`}
          >
            <a
              href="#"
              className="page-link"
              onClick={() => handlePageChange(i)}
            >
              {i}
            </a>
          </li>
        );
      }
    }

    return pages;
  };

  const handleOpenConfirmModal = (docNo) => {
    setSelectedDocNo(docNo);
    setShowConfirmModal(true);
  };

  const handleConfirmUpdateStatus = () => {
    if (selectedDocNo) {
      updateStatus(selectedDocNo);
    }
    setShowConfirmModal(false);
  };

  const searchpo = async (docNo) => {
    try {

      const response = await getData("API_0302_REC_D", `Rec_No = '${docNo}'`);

      if (!response || !Array.isArray(response)) {
        console.warn("⚠️ ไม่พบข้อมูล หรือรูปแบบข้อมูลไม่ถูกต้อง:", response);
        setPoStatusMap((prev) => ({ ...prev, [docNo]: "อนุมัติ" })); // ค่าเริ่มต้นเป็น "อนุมัติ"
        return;
      }

      const uniquePoList = Array.from(
        new Map(
          response
            .filter(
              (item) => item.PO_Number && item.AP_Name && item.DocStatus_Name
            )
            .map((item) => [
              item.PO_Number,
              {
                PO_Number: item.PO_Number,
                AP_Name: item.AP_Name,
                DocStatus_Name: item.DocStatus_Name,
              },
            ])
        ).values()
      );


      const filteredData = response
        .filter((item) => item.PO_Number && item.DocStatus_Name)
        .map((item) => item.DocStatus_Name);


      setPoStatusMap((prev) => ({ ...prev, [docNo]: filteredData }));

      setPOList(uniquePoList);
      setPoStatusMap((prev) => ({ ...prev, [docNo]: filteredData }));
      setSelectedDocNo(docNo);
      setShowConfirmModal2(true); // แสดง Modal ให้เลือก PO
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาดขณะดึงข้อมูล PO:", error);
      setPoStatusMap((prev) => ({ ...prev, [docNo]: "อนุมัติ" }));
    }
  };

  const handleConfirmClosePo = (selectedPos) => {
    selectedPos.forEach((po) => updateStatus(po?.PO_Number));
    setShowConfirmModal(false);
  };

  useEffect(() => {
    const fetchPoStatus = async () => {
      try {
        const docNos = currentItems.map((item) => item[fieldMappings.no]);

        if (docNos.length === 0) return;


        const response = await getData(
          "API_0302_REC_D",
          `Rec_No IN (${docNos.map((no) => `'${no}'`).join(", ")})`
        );

        if (!response || !Array.isArray(response)) {
          console.warn("⚠️ ไม่พบข้อมูล PO หรือรูปแบบข้อมูลผิดพลาด:", response);
          return;
        }

        const poStatusMapData = {};
        response.forEach((item) => {
          if (item.PO_Number && item.DocStatus_Name) {
            if (!poStatusMapData[item.Rec_No]) {
              poStatusMapData[item.Rec_No] = [];
            }
            poStatusMapData[item.Rec_No].push(item.DocStatus_Name);
          }
        });

        setPoStatusMap((prev) => ({ ...prev, ...poStatusMapData }));
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาดขณะดึงข้อมูล PO:", error);
      }
    };

    fetchPoStatus();
  }, [currentItems]);

  return (
    <div className="card">
      <div
        className="table-responsive"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <table
          id="basic-datatables"
          className="table table-striped table-hover"
        >
          <thead className="thead-dark">
            <tr>
              <th className="text-center" style={{ width: "2%" }}>
                เลขที่เอกสาร
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ||
                    window.location.pathname === "/invoice" ||
                    window.location.pathname === "/credit-note" ||
                    window.location.pathname === "/debit-note"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "8%" }}
              >
                {(window.location.pathname === "/credit-note" || window.location.pathname === "/debit-note")
                  ? "เลขที่ใบกำกับภาษี"
                  : "เลขที่ใบวางบิล"}
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" &&
                    localStorage.getItem("company") === "2"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "9%" }}
              >
                เลขใบกำกับภาษี
              </th>
              <th
                hidden={
                  window.location.pathname === "/product-receipt" ||
                    window.location.pathname === "/payment-voucher"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "3%" }}
              >
                เลขที่อ้างอิง
              </th>
              <th
                hidden={
                  window.location.pathname === "/product-receipt" ? false : true
                }
                className="text-center"
                style={{ width: "3%" }}
              >
                ปิดงาน
              </th>
              <th
                hidden={
                  window.location.pathname === "/picking-list" ||
                    window.location.pathname === "/billofsale" ||
                    window.location.pathname === "/credit-note" ||
                    window.location.pathname === "/debit-note"
                    ? true
                    : false
                }
                className="text-center"
                style={{ width: "2%" }}
              >
                ประเภท
              </th>
              <th
                hidden={
                  window.location.pathname === "/payment-voucher" ||
                    window.location.pathname === "/invoice"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "8%" }}
              >
                ประเภทการจ่าย
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                className="text-center"
                style={{ width: "4%" }}
              >
                ประเภท
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-request"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "6%" }}
              >
                สถานะเอกสาร
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-request" ||
                    window.location.pathname === "/payment-voucher" ||
                    window.location.pathname === "/billofsale" ||
                    window.location.pathname === "/quotation" ||
                    window.location.pathname === "/invoice"
                    ? true
                    : false
                }
                className="text-center"
                style={{
                  width: (window.location.pathname === "/credit-note" || window.location.pathname === "/debit-note") ? "6%" : "12%"
                }}
              >
                สถานะเอกสาร
              </th>
              <th
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
                className="text-center"
                style={{ width: "8%" }}
              >
                สายส่ง
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ||
                    window.location.pathname === "/invoice"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "8%" }}
              >
                สถานะจ่าย
              </th>
              <th
                hidden={
                  window.location.pathname === "/product-receipt" ? false : true
                }
                className="text-center"
                style={{ width: "12%" }}
              >
                สถานะจ่าย
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                className="text-center"
                style={{ width: "8%" }}
              >
                ประเภทการจ่าย
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-order" ? false : true
                }
                className="text-center"
                style={{ width: "10%" }}
              >
                สถานะรับสินค้า
              </th>
              <th className="text-center" style={{ width: "2%" }}>
                วันที่เอกสาร
              </th>
              <th
                className="text-center"
                hidden={
                  window.location.pathname === "/picking-list" ||
                    window.location.pathname === "/credit-note" ||
                    window.location.pathname === "/debit-note" ? true : false
                }
                style={{ width: "2%" }}
              >
                {window.location.pathname === "/purchase-request" ? "วันที่สร้าง" : "Due Date"}
              </th>
              <th
                className="text-center"
                style={{ width: "5%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                {window.location.pathname === "/quotation" ||
                  window.location.pathname === "/deposit-document" ||
                  window.location.pathname === "/billofsale" ||
                  window.location.pathname === "/invoice"
                  ? "รหัสลูกค้า"
                  : "รหัสเจ้าหนี้"}
              </th>
              <th
                className="text-center"
                style={
                  window.location.pathname === "/purchase-order" ||
                    window.location.pathname !== "/product-receipt" ||
                    window.location.pathname !== "/payment-voucher"
                    ? { width: "13%" }
                    : { width: "40%" }
                }
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                {window.location.pathname === "/quotation" ||
                  window.location.pathname === "/deposit-document" ||
                  window.location.pathname === "/billofsale" ||
                  window.location.pathname === "/invoice"
                  ? " ชื่อลูกค้า"
                  : " ชื่อเจ้าหนี้"}
              </th>
              <th
                hidden={
                  window.location.pathname === "/deposit-document" ||
                    window.location.pathname === "/billofsale"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "8%" }}
              >
                สายส่ง
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
              >
                คนขับรถที่ 1
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
              >
                คนขับรถที่ 2
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
              >
                คนขับรถที่ 3
              </th>
              <th
                className="text-center"
                style={{ width: "8%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
              >
                ทะเบียนรถ
              </th>
              <th
                className="text-center"
                style={{ width: "7%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                ยอดรวม
              </th>
              <th
                className="text-center"
                style={{ width: "6%" }}
                hidden={
                  window.location.pathname === "/billofsale" ||
                    window.location.pathname === "/invoice"
                    ? true
                    : false
                }
              >
                สร้างรายการ โดย
              </th>
              {/* <th
                hidden={
                  window.location.pathname === "/billofsale" ||
                    window.location.pathname === "/payment-voucher"
                    ? true
                    : false
                }
                className="text-center"
                style={{ width: "10%" }}
              >
                แก้ไขล่าสุด โดย
              </th> */}
              <th
                className="text-center"
                style={{ width: "1%" }}
                hidden={
                  !(
                    window.location.pathname === "/purchase-request" ||
                    window.location.pathname === "/payment-voucher"
                  )
                }
              >
                ไฟล์
              </th>
              <th className="text-center" style={{ width: "1%" }}>
                แก้ไข
              </th>
              {/* Revise  */}
              <th
                className="text-center"
                style={{ width: "1%" }}
                hidden={
                  // window.location.pathname === "/payment-voucher" ||
                  window.location.pathname === "/quotation" ? false : true
                }
              >
                Revise

              </th>
              <th
                className="text-center"
                style={{ width: "1%" }}
                hidden={
                  // window.location.pathname === "/payment-voucher" ||
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                พิมพ์
              </th>
              <th
                className="text-center"
                style={{ width: "2%" }}
                hidden={
                  // window.location.pathname === "/payment-voucher" ||
                  window.location.pathname !== "/purchase-request"
                    ? true
                    : false
                }
              >
                ปิดงาน
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((data, index) => {
                const safeMap = fieldMappings || {};
                const { code, name } = getApOrArCode(data);
                const rowId = data[safeMap.no] || index + 1;
                return (
                  <tr
                    key={rowId}
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        selectedRow === rowId
                          ? "rgb(105, 188, 216)"
                          : "transparent",
                      transition: "background-color 0.3s ease",
                    }}
                    onClick={() => setSelectedRow(rowId)}
                  >
                    <td className="text-center">
                      {/* ถ้าเป็นหน้า Quotation ถ้า rev มีข้อมูล ให้แสดง no+"Rev".rev ถ้าไม่มีให้แสดง no */}
                      {window.location.pathname === "/quotation"
                        ? data[fieldMappings.rev]
                          ? `${data[fieldMappings.no]} Rev.${data[fieldMappings.rev]}`
                          : data[fieldMappings.no]
                        : data[fieldMappings.no] || "-"}
                    </td>

                    <td
                      hidden={
                        window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/invoice" ||
                          window.location.pathname === "/credit-note" ||
                          window.location.pathname === "/debit-note"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {(window.location.pathname === "/credit-note" || window.location.pathname === "/debit-note")
                        ? data[fieldMappings.docInvNo] || "-"
                        : data[fieldMappings.docBlNo] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/billofsale" &&
                          localStorage.getItem("company") === "2"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.docInvNo] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/product-receipt" ||
                          window.location.pathname === "/payment-voucher"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.refDoc] || "-"}
                    </td>
                    {/* ปิดงาน */}
                    <td
                      hidden={window.location.pathname !== "/product-receipt"}
                      className="text-center"
                    >
                      {poStatusMap[data[fieldMappings.no]] &&
                        poStatusMap[data[fieldMappings.no]].every(
                          (status) => status === "ปิดงาน"
                        ) ? (
                        <button className="btn btn-link btn-sm px-3">
                          <i
                            className="fa fa-check-circle"
                            style={{
                              fontSize: "16px",
                              color: "rgb(19, 161, 14)",
                            }}
                          ></i>
                        </button>
                      ) : (
                        <button
                          className="btn btn-link btn-sm px-3"
                          onClick={() => searchpo(data[fieldMappings.no])}
                        >
                          <i
                            className="fa fa-clock"
                            style={{
                              fontSize: "16px",
                              color: "rgb(234, 163, 0)",
                            }}
                          ></i>
                        </button>
                      )}
                    </td>

                    <td
                      hidden={
                        window.location.pathname === "/payment-voucher" ||
                          window.location.pathname === "/picking-list" ||
                          window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/invoice" ||
                          (window.location.pathname === "/credit-note" || window.location.pathname === "/debit-note")
                          ? true
                          : false
                      }
                      className="text-center"
                      style={{ fontSize: "12px" }}
                    >
                      {data[fieldMappings.typeName] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/invoice"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {/* {data[fieldMappings.docIsPickingList]} */}

                      <button
                        className="btn"
                        style={{
                          backgroundColor:
                            data[fieldMappings.docIsPickingList] === 0 ||
                              data[fieldMappings.docIsPickingList] === null
                              ? "#EAA300"
                              : "#13A10E",
                          color: "white",
                          width: "100%",
                        }}
                      >
                        {data[fieldMappings.docIsPickingList] === 0 ||
                          data[fieldMappings.docIsPickingList] === null
                          ? "S"
                          : "V"}
                      </button>
                    </td>
                    <td
                      className="text-left"
                      style={{ fontSize: "12px" }}
                      hidden={
                        window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/quotation" ||
                          window.location.pathname === "/invoice"
                          ? true
                          : false
                      }
                    >
                      {data[fieldMappings.statusName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor: data[fieldMappings.statusColor],
                            color: "white",
                            width: "100%",
                            fontSize: "12px",
                          }}
                        >
                          {data[fieldMappings.statusName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/payment-voucher"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.payTypeName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor: data[fieldMappings.statusColor],
                            color: "white",
                            width: "100%",
                            fontSize: "12px",
                          }}
                        >
                          {data[fieldMappings.payTypeName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.dlLineName] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/purchase-order"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusReceiveColor],
                            color: "white",
                            width: "100%",
                            fontSize: "12px",
                          }}
                        >
                          {data[fieldMappings.statusReceiveName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/product-receipt"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusPaidName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusPaidColour],
                            color: "white",
                            width: "100%",
                            fontSize: "12px",
                          }}
                        >
                          {data[fieldMappings.statusPaidName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/invoice"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusName] === "ยกเลิก" ? (
                        data[fieldMappings.statusName] ? (
                          <button
                            className="btn"
                            style={{
                              backgroundColor: data[fieldMappings.statusColour],
                              color: "white",
                              width: "100%",
                              fontSize: "12px",
                            }}
                          >
                            {data[fieldMappings.statusName]}
                          </button>
                        ) : (
                          <center>
                            <p>-</p>
                          </center>
                        )
                      ) : data[fieldMappings.statusPaidName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusPaidColour],
                            color: "white",
                            width: "100%",
                            fontSize: "12px",
                          }}
                        >
                          {data[fieldMappings.statusPaidName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/invoice"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusPaidTypeName] !== null ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusPaidTypeColour],
                            color: "white",
                            width: "100%",
                            fontSize: "12px",
                          }}
                        >
                          {data[fieldMappings.statusPaidTypeName]}
                        </button>
                      ) : (
                        <>
                          {data[fieldMappings.statusName] === "ยกเลิก" ? (
                            data[fieldMappings.statusName] ? (
                              <button
                                className="btn"
                                style={{
                                  backgroundColor:
                                    data[fieldMappings.statusColour],
                                  color: "white",
                                  width: "100%",
                                  fontSize: "12px",
                                }}
                              >
                                {data[fieldMappings.statusName]}
                              </button>
                            ) : (
                              <center>
                                <p>-</p>
                              </center>
                            )
                          ) : data[fieldMappings.statusPaidName] ? (
                            <button
                              className="btn"
                              style={{
                                backgroundColor:
                                  data[fieldMappings.statusPaidColour],
                                color: "white",
                                width: "100%",
                                fontSize: "12px",
                              }}
                            >
                              {data[fieldMappings.statusPaidName]}
                            </button>
                          ) : (
                            <center>
                              <p>-</p>
                            </center>
                          )}
                        </>
                      )}
                    </td>
                    <td className="text-center">
                      {data[fieldMappings.date]
                        ? formatDate(data[fieldMappings.date])
                        : "-"}
                    </td>
                    <td
                      className="text-center"
                      hidden={
                        window.location.pathname === "/picking-list" ||
                          window.location.pathname === "/credit-note" ||
                          window.location.pathname === "/debit-note"
                          ? true
                          : false
                      }
                    >
                      {data[fieldMappings.dueDate]
                        ? formatDate(data[fieldMappings.dueDate])
                        : "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                      className="text-center"
                    >
                      {code || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                      className="text-left"
                    >
                      {name || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/deposit-document" ||
                          window.location.pathname === "/billofsale"
                          ? //  ||window.location.pathname === "/invoice"
                          false
                          : true
                      }
                    >
                      {data[fieldMappings.dlLineName] || "-"}
                    </td>
                    <td
                      className="text-end"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                    >
                      {formatCurrency(data[fieldMappings.netTotal] || 0.0)}
                    </td>

                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.driver1] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.driver2] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.driver3] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.carNo] || "-"}
                    </td>

                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/invoice"
                          ? true
                          : false
                      }
                    >
                      {data[fieldMappings.createdBy] || "-"}
                    </td>

                    {/* <td
                      hidden={
                        window.location.pathname === "/billofsale"
                          || window.location.pathname === "/payment-voucher"
                          ? true
                          : false
                      }
                      className="text-left">
                      {data[fieldMappings.updatedBy] || "-"}
                    </td> */}

                    <td
                      hidden={
                        !(
                          window.location.pathname === "/purchase-request" ||
                          window.location.pathname === "/payment-voucher"
                        )
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.File_Name]?.length > 0 ? (
                        <button
                          className="btn btn-link btn-sm px-3"
                          onClick={() =>
                            handleShowModal(data[fieldMappings.File_Name])
                          }
                        >
                          <i
                            className="fas fa-paperclip"
                            style={{
                              fontSize: "16px",
                              color: "rgb(239, 108, 0)",
                            }}
                          ></i>
                        </button>
                      ) : (
                        "-"
                      )}
                      {showModal && (
                        <FileModal
                          showModal={showModal}
                          handleClose={handleClose}
                          Files={selectedFiles}
                          mode={"S"}
                        />
                      )}
                    </td>

                    <td className="text-center">
                      <button
                        className="btn btn-link btn-sm px-3"
                        onClick={() => onRowSelected(data[fieldMappings.no])}
                      >
                        <i
                          className="fa fa-edit"
                          style={{
                            color: "rgb(239, 108, 0)",
                            fontSize: "16px",
                          }}
                        ></i>
                      </button>
                    </td>
                    {/* Revise */}
                    <td className="text-center" hidden={
                      // window.location.pathname === "/payment-voucher" ||
                      window.location.pathname === "/quotation" ? false : true
                    }>
                      <button
                        className="btn btn-link btn-sm px-3"
                        onClick={() => onRevise(data[fieldMappings.no])}
                      >
                        <i
                          className="fa fa-pencil-alt"
                          style={{
                            color: "rgb(239, 108, 0)",
                            fontSize: "16px",
                          }}
                        ></i>
                      </button>
                    </td>
                    <td
                      hidden={
                        // window.location.pathname === "/payment-voucher" ||
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                      className="text-center"
                    >
                      {window.location.pathname === "/payment-voucher" ? (
                        <button
                          className="btn btn-link btn-sm px-3"
                          onClick={() =>
                            getReport(
                              data[fieldMappings.Pay_Trans_Type] === 2
                                ? "PAY_CHEQUE"
                                : "PAY_CASH",
                              data[fieldMappings.no]
                            )
                          }
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                        </button>
                      ) : (
                        <button
                          className="btn btn-link btn-sm px-3"
                          onClick={() => getReport(data[fieldMappings.no])}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                        </button>
                      )}
                    </td>

                    <td
                      hidden={window.location.pathname !== "/purchase-request"}
                      className="text-center"
                    >
                      {data[fieldMappings.statusName] === "อนุมัติ" ? (
                        <button
                          className="btn btn-link btn-sm px-3"
                          onClick={() => {
                            handleOpenConfirmModal(data[fieldMappings.no]);
                          }}
                        >
                          <i
                            className="fa fa-clock"
                            style={{
                              fontSize: "16px",
                              color: "rgb(234, 163, 0)",
                            }}
                          ></i>
                        </button>
                      ) : data[fieldMappings.statusName] === "ปิดงาน" ? (
                        <button
                          className="btn btn-link btn-sm px-3"
                        // onClick={() => {
                        //   handleOpenConfirmModal(data[fieldMappings.no]);
                        // }}
                        >
                          <i
                            className="fa fa-check-circle"
                            style={{
                              fontSize: "16px",
                              color: "rgb(19, 161, 14)",
                            }}
                          ></i>
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={14}>
                  <center>
                    <h5>ไม่พบข้อมูล</h5>
                  </center>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {showConfirmModal && (
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">ยืนยันการปิดงาน PO</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => setShowConfirmModal(false)}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p>คุณแน่ใจหรือไม่ว่าต้องการปิดงานใบ PO นี้?</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowConfirmModal(false)}
                  >
                    ยกเลิก
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleConfirmUpdateStatus}
                  >
                    ยืนยัน
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <PoSelectionModal
          show={showConfirmModal2}
          onClose={() => setShowConfirmModal2(false)}
          poList={POList}
          onConfirm={handleConfirmClosePo}
          updateStatus={updateStatus}
        />
      </div>
      {/* Pagination */}
      <div className="row mt-3">
        <div className="col-12 d-flex justify-content-end">
          <div
            className="dataTables_paginate paging_simple_numbers"
            id="basic-datatables_paginate"
          >
            <ul className="pagination">
              <li
                className={`paginate_button page-item previous ${currentPage === 1 ? "disabled" : ""
                  }`}
              >
                <a
                  href="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </a>
              </li>
              {renderPageNumbers()}
              <li
                className={`paginate_button page-item next ${currentPage ===
                  Math.ceil(dataMasterList.length / itemsPerPage)
                  ? "disabled"
                  : ""
                  }`}
              >
                <a
                  href="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTable;
